module.exports = __webpack_public_path__ + "img/center-default-bg.4a0020c5.png";